// extracted by mini-css-extract-plugin
export var childrenContainer = "_do-0";
export var virtualScrollArea = "_do-1";